/* ppMix engine — see snippets/pp-mix-engine.liquid for what it does. Moved out of the page HTML 2026-10-03 so
   browsers cache it once instead of downloading ~18KB inside every page (it was printed twice on every PDP). */
  (function () {
    if (window.ppMixEngine) return;
    // --- Pure pixel core. NO document/window here: this function is also stringified into a Web Worker. ---
    function ppMixCore() {
      var mkCanvas = function (w, h) {
        if (typeof document !== 'undefined') { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }
        return new OffscreenCanvas(w, h);
      };
      var toBlob = function (cv) {
        if (cv.convertToBlob) return cv.convertToBlob({ type: 'image/jpeg', quality: 0.96 });
        return new Promise(function (res) { cv.toBlob(res, 'image/jpeg', 0.96); });
      };
      var SHADE = { top: [.64, .64, .723, .755, .776, .81, .843, .891, .931, .958, .986],
                              bottom: [.985, .981, .966, .914, .854, .791, .725, .71, .711, .726],
                              left: [.893, .843, .864, .951, .972, .98],
                              right: [.997, .992, .959, .98, .956, .949, .943, .947, .944, .934, .959, .958, .945, .943, .936, .918, .916, .92, .909, .894,
                                      .897, .887, .87, .861, .856, .846, .821, .805, .793, .77, .752, .726, .702, .695, .666, .598] };
      // Page colour behind the print. Only the white-background preview sets it (window.PP_PAGE, or the worker's own var).
      var PAGE = typeof PP_PAGE !== 'undefined' ? PP_PAGE : null;
      var MIX = {
        tpl: {
          '3': { w: 1024, h: 1366, poster: [43, 952, 42, 1323], frame: [23, 976, 20, 1345], art: [77, 918, 76, 942], src: 'x', shade: SHADE },
          '4': { w: 1024, h: 1366, poster: [43, 952, 42, 1323], frame: [23, 976, 20, 1345], art: [68, 927, 65, 1057], src: 'x', shade: SHADE },
          // Styles 1/2/6 (Matte/Satin/Gloss): same frame template, free-form designs -> frame colour + bare print only.
          // shade = the frame's shadow on the paper at each edge (measured once from the template), removed for "No Frame".
          'p': { w: 1024, h: 1366, poster: [43, 952, 42, 1323], frame: [23, 976, 20, 1345], art: null, src: null,
                 shade: SHADE },
          '5': { w: 1196, h: 1196, poster: [62, 1122, 66, 1120], frame: [50, 1137, 52, 1136], art: [98, 1084, 102, 1000], src: 'y' }
        },
        pal: { x: [[205, 201, 179], [65, 89, 93]], y: [[255, 255, 255], [114, 111, 111]], z: [[121, 113, 97], [237, 229, 214]] },
        frames: { white: { base: 240, gain: 0.30, tint: [1, 0.995, 0.985] }, black: { base: 38, gain: 0.28, tint: [1, 1, 1] } }
      };
      var pct = function (arr, p) { if (!arr.length) return 0; arr.sort(function (a, b) { return a - b; }); return arr[Math.min(arr.length - 1, Math.floor(arr.length * p))]; };
      var smooth = function (v) {
        var out = new Float32Array(v.length), r = 5;
        for (var i = 0; i < v.length; i++) { var s = 0, n = 0; for (var k = -r; k <= r; k++) { var j = Math.min(v.length - 1, Math.max(0, i + k)); s += v[j]; n++; } out[i] = s / n; }
        return out;
      };
      // One-off analysis of the source: brightness + a smooth shading field for the poster's panel/border.
      // trusted = the caller knows im IS this template (e.g. the custom builder's own example thumbnails): skip the
      // page-colour/oak-frame sanity check, which exact-pixel browser quirks (colour management, Safari's canvas
      // fingerprinting noise) can trip even though the image is right.
      var mixPrepare = function (im, tpl, trusted) {
        var T = MIX.tpl[tpl], IW = T.w, IH = T.h;
        var cv = mkCanvas(IW, IH);
        var cx = cv.getContext('2d'); cx.imageSmoothingQuality = 'high'; cx.drawImage(im, 0, 0, IW, IH);
        var d = cx.getImageData(0, 0, IW, IH).data;
        var P = T.poster, A = T.art, F = T.frame, W = P[1] - P[0], H = P[3] - P[2];
        // Is this really the template? Page-colour corners + a warm oak band where the frame should be.
        var near = function (k) { return Math.abs(d[k] - 249) < 9 && Math.abs(d[k + 1] - 233) < 9 && Math.abs(d[k + 2] - 220) < 9; };
        var okBg = near((6 * IW + 4) * 4) && near((6 * IW + IW - 5) * 4) && near(((IH - 6) * IW + 4) * 4);
        var fr0 = 0, fb0 = 0, fc0 = 0, fyM = Math.round((P[2] + P[3]) / 2);
        for (var fy = fyM - 200; fy < fyM + 200; fy += 4) for (var fx = F[0] + 3; fx < P[0] - 3; fx++) { var k0 = (fy * IW + fx) * 4; fr0 += d[k0]; fb0 += d[k0 + 2]; fc0++; }
        if (!trusted && (!okBg || !fc0 || (fr0 - fb0) / fc0 < 18)) return { bad: true, tpl: tpl };
        if (!T.src) {
          var fs0 = 0, fn0 = 0;
          for (y = F[2]; y < F[3]; y += 2) for (x = F[0]; x < F[1]; x += 2) {
            if (x >= P[0] && x < P[1] && y >= P[2] && y < P[3]) continue;
            i = (y * IW + x) * 4; fs0 += (d[i] + d[i + 1] + d[i + 2]) / 3; fn0++;
          }
          return { data: d, tpl: tpl, frameL: fn0 ? fs0 / fn0 : 175 };
        }
        var px = MIX.pal[T.src], thr = ((px[0][0] + px[0][1] + px[0][2]) + (px[1][0] + px[1][1] + px[1][2])) / 6;
        // The artwork doesn't always reach the template's art box: most Square files stop 9px short of it, and that
        // strip of the thumbnail's own paper stayed white under a recoloured print (2026-11-03). Pull the box's bottom
        // up past any rows that are plain paper colour, so they get repainted with the rest of the paper.
        var artB = A[3], pb = px[0];
        for (var by = A[3] - 1; by > A[3] - 16; by--) {
          var bs = 0, bn = 0, bo = 0;
          for (var bx = A[0] + 4; bx < A[1] - 4; bx += 3) {
            var bk = (by * IW + bx) * 4; bn++;
            if (Math.abs(d[bk] - pb[0]) < 16 && Math.abs(d[bk + 1] - pb[1]) < 16 && Math.abs(d[bk + 2] - pb[2]) < 16) bs++; else bo++;
          }
          if (bs / bn < 0.97) break;
          artB = by;
        }
        A = [A[0], A[1], A[2], artB];
        var inPanel = function (x, y) { return !(x >= A[0] && x < A[1] && y >= A[2] && y < A[3]); };
        var rows = [], cols = [], i, x, y;
        for (y = 0; y < H; y++) rows.push([]);
        for (x = 0; x < W; x++) cols.push([]);
        for (y = P[2]; y < P[3]; y++) for (x = P[0]; x < P[1]; x++) {
          if (!inPanel(x, y)) continue;
          i = (y * IW + x) * 4; var L = (d[i] + d[i + 1] + d[i + 2]) / 3;
          if (L <= thr) continue;                    // background pixels only (skip text/rules)
          rows[y - P[2]].push(L); cols[x - P[0]].push(L);
        }
        var rowP = new Float32Array(H), colP = new Float32Array(W), all = [];
        for (y = 0; y < H; y++) { rowP[y] = pct(rows[y], 0.5); if (rows[y].length) all.push(rowP[y]); }
        var fill = pct(all, 0.5) || 195;
        for (y = 0; y < H; y++) if (!rows[y].length) rowP[y] = fill;
        for (x = 0; x < W; x++) colP[x] = cols[x].length ? pct(cols[x], 0.5) : fill;
        rowP = smooth(rowP); colP = smooth(colP);
        var ref = pct(Array.prototype.slice.call(rowP), 0.5) || 1;
        var fs = 0, fn = 0;                          // mean brightness of the thumbnail's own (oak) frame
        for (y = F[2]; y < F[3]; y += 2) for (x = F[0]; x < F[1]; x += 2) {
          if (x >= P[0] && x < P[1] && y >= P[2] && y < P[3]) continue;
          i = (y * IW + x) * 4; fs += (d[i] + d[i + 1] + d[i + 2]) / 3; fn++;
        }
        return { data: d, rowP: rowP, colP: colP, ref: ref, tpl: tpl, frameL: fn ? fs / fn : 175, art: A };
      };
      var mixRender = function (prep, style, frame) {
        var src = prep.data, out = new Uint8ClampedArray(src);
        var T = MIX.tpl[prep.tpl], IW = T.w, IH = T.h;
        var P = T.poster, A = prep.art || T.art, F = T.frame, x, y, i;
        var bare = frame === 'none';                 // unframed: flat lighting (no frame lip shadow on the paper)
        var sh = T.shade, W0 = P[1] - P[0], H0 = P[3] - P[2];
        var shY = function (y) { var yy = y - P[2]; return yy < sh.top.length ? sh.top[yy] : (H0 - 1 - yy < sh.bottom.length ? sh.bottom[sh.bottom.length - 1 - (H0 - 1 - yy)] : 1); };
        var shX = function (x) { var xx = x - P[0]; return xx < sh.left.length ? sh.left[xx] : (W0 - 1 - xx < sh.right.length ? sh.right[sh.right.length - 1 - (W0 - 1 - xx)] : 1); };
        if (bare && sh) {
          // Divide out the frame's measured edge shadow everywhere on the paper (artwork included) so the print
          // reads evenly lit; palette templates are then re-painted below from this flattened copy.
          for (y = P[2]; y < P[3]; y++) {
            var sy0 = shY(y);
            for (x = P[0]; x < P[1]; x++) {
              var g = 1 / (sy0 * shX(x)); i = (y * IW + x) * 4;
              out[i] = src[i] * g; out[i + 1] = src[i + 1] * g; out[i + 2] = src[i + 2] * g;
            }
          }
        }
        if (T.src && (style !== T.src || bare)) {
          var bx = MIX.pal[T.src][0], fx = MIX.pal[T.src][1], nb = MIX.pal[style][0], nf = MIX.pal[style][1];
          var Lb = (bx[0] + bx[1] + bx[2]) / 3, Lf = (fx[0] + fx[1] + fx[2]) / 3;
          for (y = P[2]; y < P[3]; y++) {
            var ry = prep.rowP[y - P[2]] / Lb;
            for (x = P[0]; x < P[1]; x++) {
              if (x >= A[0] && x < A[1] && y >= A[2] && y < A[3]) continue;
              i = (y * IW + x) * 4;
              var L = (src[i] + src[i + 1] + src[i + 2]) / 3, s, t;
              var edge = Math.min(x - P[0], P[1] - 1 - x, y - P[2], P[3] - 1 - y);
              if (bare && sh && edge < 18) {
                // Bare print, outer margin: the template never has text this close to the edge, and the frame's
                // shadow sits here -> pure solid paper colour (fixes the dark band along the top of "No Frame").
                s = 1; t = 0;
              } else if (bare && sh) {
                // Classify text vs paper against the known frame shadow (no hard edge band), render flat.
                var sc = (prep.ref / Lb) * shY(y) * shX(x);
                t = (sc * Lb - L) / (sc * (Lb - Lf)); t = t < 0 ? 0 : t > 1 ? 1 : t; s = 1;
              } else if (edge < 14) {
                // Outer margin: never text, only the frame's lip shadow -> keep its darkness (framed) or drop it (bare)
                s = bare ? 1 : L / Lb; t = 0;
              } else {
                s = ry * (prep.colP[x - P[0]] / prep.ref);
                t = (s * Lb - L) / (s * (Lb - Lf)); t = t < 0 ? 0 : t > 1 ? 1 : t;
                if (bare) s = 1;                     // classify with the real lighting, render flat
              }
              s = s < 0.3 ? 0.3 : s > 1.15 ? 1.15 : s;
              out[i] = s * (nb[0] + t * (nf[0] - nb[0])); out[i + 1] = s * (nb[1] + t * (nf[1] - nb[1])); out[i + 2] = s * (nb[2] + t * (nf[2] - nb[2]));
            }
          }
        }
        if (bare && sh && !T.src) {
          // Free-form designs (styles 1/2/6) have no palette to repaint, and the frame's shadow on the paper reaches
          // ~50px in. Per edge: sample a strip just beyond it; if that strip is one flat colour (solid-colour designs,
          // most of styles 1/2), snap paper-coloured pixels within 60px of the edge to it -> clean solid edge. Text and
          // art (colour far from the paper) are untouched, and a painted edge (watercolour) fails the flatness test and
          // is left exactly as it was.
          var D = 60, S0 = 62, S1 = 74, tol = 0.14;
          var strip = function (x0, x1, y0, y1) {
            var r = [], g = [], b = [], L = [];
            for (var yy = y0; yy < y1; yy += 2) for (var xx = x0; xx < x1; xx += 3) { var k = (yy * IW + xx) * 4; r.push(out[k]); g.push(out[k + 1]); b.push(out[k + 2]); L.push((out[k] + out[k + 1] + out[k + 2]) / 3); }
            var m = pct(L.slice(), 0.5), sd = 0; for (var q = 0; q < L.length; q++) sd += (L[q] - m) * (L[q] - m); sd = Math.sqrt(sd / (L.length || 1));
            var inl = 0; for (q = 0; q < L.length; q++) if (Math.abs(L[q] - m) < 6) inl++;
            return { c: [pct(r, 0.5), pct(g, 0.5), pct(b, 0.5)], L: m, flat: inl / (L.length || 1) > 0.9 };
          };
          var edges = [
            { ref: strip(P[0] + D, P[1] - D, P[2] + S0, P[2] + S1), hit: function (x, y) { return y - P[2] < D; } },
            { ref: strip(P[0] + D, P[1] - D, P[3] - S1, P[3] - S0), hit: function (x, y) { return P[3] - 1 - y < D; } },
            { ref: strip(P[0] + S0, P[0] + S1, P[2] + D, P[3] - D), hit: function (x, y) { return x - P[0] < D; } },
            { ref: strip(P[1] - S1, P[1] - S0, P[2] + D, P[3] - D), hit: function (x, y) { return P[1] - 1 - x < D; } }
          ];
          for (y = P[2]; y < P[3]; y++) for (x = P[0]; x < P[1]; x++) {
            for (var e = 0; e < 4; e++) {
              var E = edges[e]; if (!E.ref.flat || !E.hit(x, y)) continue;
              i = (y * IW + x) * 4; var Lp = (out[i] + out[i + 1] + out[i + 2]) / 3;
              var ed = Math.min(y - P[2], P[3] - 1 - y, x - P[0], P[1] - 1 - x);
              if (ed < 6 || Math.abs(Lp - E.ref.L) <= E.ref.L * tol) { out[i] = E.ref.c[0]; out[i + 1] = E.ref.c[1]; out[i + 2] = E.ref.c[2]; }
              break;
            }
          }
          // Painted (non-flat) edges: the outer 6px still carry the frame lip (oak streaks) -> repeat the paint just inside.
          var LIP = 6, cp = function (dx, dy, sx, sy) { var a1 = (dy * IW + dx) * 4, b1 = (sy * IW + sx) * 4; out[a1] = out[b1]; out[a1 + 1] = out[b1 + 1]; out[a1 + 2] = out[b1 + 2]; };
          for (x = P[0]; x < P[1]; x++) {
            if (!edges[0].ref.flat) for (y = P[2]; y < P[2] + LIP; y++) cp(x, y, x, P[2] + LIP);
            if (!edges[1].ref.flat) for (y = P[3] - LIP; y < P[3]; y++) cp(x, y, x, P[3] - LIP - 1);
          }
          for (y = P[2]; y < P[3]; y++) {
            if (!edges[2].ref.flat) for (x = P[0]; x < P[0] + LIP; x++) cp(x, y, P[0] + LIP, y);
            if (!edges[3].ref.flat) for (x = P[1] - LIP; x < P[1]; x++) cp(x, y, P[1] - LIP - 1, y);
          }
        }
        var fr = MIX.frames[frame];
        if (fr) {
          for (y = F[2]; y < F[3]; y++) for (x = F[0]; x < F[1]; x++) {
            if (x >= P[0] && x < P[1] && y >= P[2] && y < P[3]) continue;
            i = (y * IW + x) * 4;
            var v = fr.base + ((src[i] + src[i + 1] + src[i + 2]) / 3 - prep.frameL) * fr.gain;
            out[i] = v * fr.tint[0]; out[i + 1] = v * fr.tint[1]; out[i + 2] = v * fr.tint[2];
          }
        }
        var cv = mkCanvas(IW, IH);
        var cx = cv.getContext('2d');
        if (bare) {
          // No frame: the print alone on the page background with a soft contact shadow.
          cx.fillStyle = PAGE || 'rgb(249,233,220)'; cx.fillRect(0, 0, IW, IH);
          cx.save(); cx.shadowColor = 'rgba(70, 45, 25, .26)'; cx.shadowBlur = 34; cx.shadowOffsetY = 12;
          // The frame lip overlapped the print by a few px: give that paper back by extending the edge pixels outward.
          var X = 3, B = [P[0] - X, P[1] + X, P[2] - X, P[3] + X];
          for (y = B[2]; y < B[3]; y++) for (x = B[0]; x < B[1]; x++) {
            if (x >= P[0] && x < P[1] && y >= P[2] && y < P[3]) continue;
            var cxp = x < P[0] ? P[0] + 1 : x >= P[1] ? P[1] - 2 : x, cyp = y < P[2] ? P[2] + 1 : y >= P[3] ? P[3] - 2 : y;
            var d = (y * IW + x) * 4, sI = (cyp * IW + cxp) * 4;
            out[d] = out[sI]; out[d + 1] = out[sI + 1]; out[d + 2] = out[sI + 2];
          }
          cx.fillStyle = '#fff'; cx.fillRect(B[0], B[2], B[1] - B[0], B[3] - B[2]); cx.restore();
          cx.putImageData(new ImageData(out, IW, IH), 0, 0, B[0], B[2], B[1] - B[0], B[3] - B[2]);
        } else if (PAGE) {
          // White-background preview: replace the template's cream margin and baked-in shadow around the frame.
          cx.fillStyle = PAGE; cx.fillRect(0, 0, IW, IH);
          cx.save(); cx.shadowColor = 'rgba(31, 34, 39, .24)'; cx.shadowBlur = 30; cx.shadowOffsetY = 10;
          cx.fillStyle = '#fff'; cx.fillRect(F[0], F[2], F[1] - F[0], F[3] - F[2]); cx.restore();
          cx.putImageData(new ImageData(out, IW, IH), 0, 0, F[0], F[2], F[1] - F[0], F[3] - F[2]);
        } else {
          cx.putImageData(new ImageData(out, IW, IH), 0, 0);
        }
        return toBlob(cv);                         // Promise<Blob> (object URL is made by the caller)
      };
      return { MIX: MIX, prepare: mixPrepare, render: mixRender };
    }

    var core = ppMixCore();
    var loadImg = function (src) {
      return new Promise(function (res, rej) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = rej; im.src = src; });
    };
    var render = function (prep, style, frame) {
      return core.render(prep, style, frame).then(function (b) { return URL.createObjectURL(b); });
    };

    // --- Worker path: fetch + decode + prepare + render off the main thread. ---
    var worker = null, workerDead = false, seq = 0, pending = {};
    var getWorker = function () {
      if (worker || workerDead) return worker;
      try {
        if (typeof Worker === 'undefined' || typeof OffscreenCanvas === 'undefined' || typeof createImageBitmap === 'undefined') throw 0;
        var code = 'var PP_PAGE = ' + JSON.stringify(window.PP_PAGE || null) + ';\n' +
          'var api = (' + ppMixCore.toString() + ')(); var preps = {};\n' +
          'self.onmessage = function (e) { var m = e.data;\n' +
          '  var p = preps[m.src + "|" + m.tpl];\n' +
          '  if (!p) p = preps[m.src + "|" + m.tpl] = fetch(m.src).then(function (r) { if (!r.ok) throw new Error("fetch " + r.status); return r.blob(); })\n' +
          '    .then(function (b) { return createImageBitmap(b); }).then(function (bm) { var pr = api.prepare(bm, m.tpl); if (bm.close) bm.close(); return pr; });\n' +
          '  p.then(function (prep) { if (prep.bad) { postMessage({ id: m.id, bad: true }); return; }\n' +
          '    return api.render(prep, m.style, m.frame).then(function (blob) { postMessage({ id: m.id, blob: blob }); }); })\n' +
          '   .catch(function (err) { postMessage({ id: m.id, error: String(err && err.message || err) }); });\n' +
          '};';
        worker = new Worker(URL.createObjectURL(new Blob([code], { type: 'text/javascript' })));
        worker.onmessage = function (e) {
          var m = e.data, cb = pending[m.id]; if (!cb) return; delete pending[m.id];
          if (m.error) cb.reject(new Error(m.error));
          else if (m.bad) cb.resolve({ bad: true });
          else cb.resolve({ url: URL.createObjectURL(m.blob) });
        };
        worker.onerror = function () { workerDead = true; var w = worker; worker = null; try { w.terminate(); } catch (e) {}
          Object.keys(pending).forEach(function (k) { var cb = pending[k]; delete pending[k]; cb.reject(new Error('worker')); }); };
      } catch (e) { workerDead = true; worker = null; }
      return worker;
    };
    var mainPreps = {};
    var renderMain = function (src, tpl, style, frame) {
      var k = src + '|' + tpl;
      if (!mainPreps[k]) mainPreps[k] = loadImg(src).then(function (im) { return core.prepare(im, tpl); });
      return mainPreps[k].then(function (prep) {
        if (prep.bad) return { bad: true };
        return render(prep, style, frame).then(function (url) { return { url: url }; });
      });
    };
    var renderAsync = function (src, tpl, style, frame) {
      var abs = src; try { abs = new URL(src, location.href).href; } catch (e) {}
      var w = getWorker();
      if (!w) return renderMain(abs, tpl, style, frame);
      return new Promise(function (resolve, reject) {
        var id = ++seq; pending[id] = { resolve: resolve, reject: reject };
        w.postMessage({ id: id, src: abs, tpl: tpl, style: style, frame: frame });
      }).catch(function () { return renderMain(abs, tpl, style, frame); });
    };

    window.ppMixEngine = { MIX: core.MIX, loadImg: loadImg, prepare: core.prepare, render: render, renderAsync: renderAsync };
  })();
